
define('text!templates/result-container.html',[],function () { return '<div class="mx-result" data-mx-result-host={{=it.host}}>\n    <h3>DEBUG: CHECKMX RESULT: {{=it.host}}</h3>\n</div>\n';});

